<template>
  <v-list-item>
    <v-list-item-action>
      <v-checkbox
        :input-value="completed"
        @change="completeHandler"
        off-icon="mdi-circle-outline"
        on-icon="mdi-check"
      >
      </v-checkbox>
    </v-list-item-action>
    <v-list-item-content>
      <v-text-field
        :readonly="!editable"
        :value="text"
        @change="editHandler"
        class="mt-0 pt-0"
        flat
        hide-details
        solo
      >
      </v-text-field>
    </v-list-item-content>
    <v-list-item-action>
      <v-checkbox
        :color="starred ? 'yellow darken-2' : ''"
        :input-value="starred"
        @change="starHandler"
        off-icon="mdi-star-outline"
        on-icon="mdi-star"
      >
      </v-checkbox>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'Todo',
  props: {
    id: {
      type: String,
    },
    text: {
      type: String,
      default: '',
    },
    completed: {
      type: Boolean,
      default: false,
    },
    starred: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    completeHandler(value) {
      this.$emit('completed', { id: this.id, value })
    },
    starHandler(value) {
      this.$emit('starred', { id: this.id, value })
    },
    editHandler(value) {
      this.$emit('edited', { id: this.id, value })
    },
  },
}
</script>
